import React from 'react';

export default function Button({ children, variant = 'primary', className = '', disabled, ...props }) {
  const baseStyle = "inline-flex items-center justify-center px-6 py-3 font-sans text-sm tracking-widest uppercase transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-saddle focus:ring-offset-2";
  
  const variants = {
    primary: "bg-navy text-cream hover:bg-saddle active:scale-95",
    secondary: "bg-transparent border border-navy text-navy hover:bg-navy hover:text-cream active:scale-95",
    accent: "bg-saddle text-cream hover:bg-navy active:scale-95"
  };

  return (
    <button 
      className={`${baseStyle} ${variants[variant]} ${className}`} 
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}